<template>
  <v-main>
    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>

          <!-- HEADER -->
          <h1 class="mb-4">{{$t("Set weight")}}</h1>
          <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>

          <div style="max-width:1100px">
            <!-- SUMMARY -->
            <div v-if="smReg != null && smReg.Registration != null">
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-layout v-if="!isHide('Article')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Article")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{smReg.Registration.ArticleNo}} - {{smReg.Registration.ArticleName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Vehicle')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Vehicle")}}:</v-flex>
                    <v-flex d-flex xs8>{{smReg.Registration.VehicleNo}} - {{smReg.Registration.VehicleLicensePlateNo}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Customer')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Customer")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{smReg.Registration.CustomerNo}} - {{smReg.Registration.CustomerName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Facility')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Facility")}}:</v-flex>
                    <v-flex d-flex xs8>{{smReg.Registration.Facility}}</v-flex>
                  </v-layout>
                  <!--v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("WeightNet")}}:</v-flex>
                    <v-flex d-flex xs8>{{getWeightStr(smReg)}}</v-flex>
                  </v-layout>
                  <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Tare")}}:</v-flex>
                    <v-flex d-flex xs8>{{smReg.TareWeight}} kg</v-flex>
                  </v-layout -->
                </v-flex>
                <v-flex xs12 md6>
                  <v-layout v-if="!isHide('RequisitionNo1')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("RequisitionNo1")}}:</v-flex>
                    <v-flex d-flex xs8>{{smReg.Registration.RequisitionNo1}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('RequisitionNo2')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("RequisitionNo2")}}:</v-flex>
                    <v-flex d-flex xs8>{{smReg.Registration.RequisitionNo2}}</v-flex>
                  </v-layout>
                  <!--v-layout v-if="!isHide('Plant')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Plant")}}:</v-flex>
                    <v-flex d-flex xs8>{{smReg.Registration.PlantNo}} - {{smReg.Registration.PlantName}}</v-flex>
                  </v-layout-->
                  <!--v-layout v-if="!isHide('Facility')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Facility")}}:</v-flex>
                    <v-flex d-flex xs8>{{smReg.Registration.Facility}}</v-flex>
                  </v-layout-->
                  <v-layout row wrap class="textsize-large mb-n4" style="padding: 2px 2px 2px 14px">
                      <v-flex d-flex xs4 class="font-weight-bold">{{$t("1. weight")}}:</v-flex>
                      <v-flex d-flex xs4 class="font-weight-bold" style="justify-content:right">{{smReg.Registration.WeightFirst}} kg</v-flex>
                    </v-layout>
                    <v-layout row wrap class="textsize-large mb-n4" style="padding: 2px 2px 2px 14px">
                      <v-flex d-flex xs4 class="font-weight-bold">{{$t("2. weight")}}:</v-flex>
                      <v-flex d-flex xs4 class="font-weight-bold" style="justify-content:right">{{smReg.Registration.WeightSecond}} kg</v-flex>
                    </v-layout>
                    <v-layout row wrap class="textsize-large mb-n4" style="padding: 2px 2px 2px 14px">
                      <v-flex d-flex xs4 class="font-weight-bold">{{$t("Netto")}}:</v-flex>
                      <v-flex d-flex xs4 class="font-weight-bold" style="justify-content:right">{{Math.abs(smReg.Registration.WeightFirst-smReg.Registration.WeightSecond)}} kg</v-flex>
                    </v-layout>
                </v-flex>
              </v-layout>
            </div>

            <div>
              <v-layout xs12 sm12 align-center >
                <v-flex>
                  <!--v-text-field  v-if="smReg != null && smReg.Registration != null && !isHide('Comment')" class="ml-2 mr-2" hide-details="true" v-model="smReg.Registration.Comment1" :maxlength="100" :label="$t('Comment')"></v-text-field-->
                  <!-- WEIGHT DISPLAY -->
                  <!--v-layout row wrap>
                  <v-flex xs12 md6>
                    <v-layout row wrap class="textsize-large mb-n4" style="padding: 2px 2px 2px 14px">
                      <v-flex d-flex xs4 class="font-weight-bold">{{$t("1. weight")}}:</v-flex>
                      <v-flex d-flex xs4 class="font-weight-bold" style="justify-content:right">{{smReg.Registration.WeightFirst}} kg</v-flex>
                    </v-layout>
                    <v-layout row wrap class="textsize-large mb-n4" style="padding: 2px 2px 2px 14px">
                      <v-flex d-flex xs4 class="font-weight-bold">{{$t("2. weight")}}:</v-flex>
                      <v-flex d-flex xs4 class="font-weight-bold" style="justify-content:right">{{smReg.Registration.WeightSecond}} kg</v-flex>
                    </v-layout>
                    <v-layout row wrap class="textsize-large mb-n4" style="padding: 2px 2px 2px 14px">
                      <v-flex d-flex xs4 class="font-weight-bold">{{$t("Netto")}}:</v-flex>
                      <v-flex d-flex xs4 class="font-weight-bold" style="justify-content:right">{{smReg.Registration.WeightFirst-smReg.Registration.WeightSecond}} kg</v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout-->
                  <v-layout row wrap class="textsize-svs" style="padding: 10px 8px 4px 8px" >
                    <v-flex d-flex xs12 sm12 class="textsize-large thin-border" style="min-height:50px; align-items:center; justify-content:center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
                      <div class="text-center">
                        {{form.weightNetString}} kg
                      </div>
                    </v-flex>
                  </v-layout>
                  <!-- NUM PAD -->
                  <v-flex d-flex sm2></v-flex>
                  <v-layout row class="textsize-svs">
                    <v-flex d-flex class="ml-n5" xs1 sm1></v-flex>
                    <v-flex d-flex xs3 sm2><v-btn block color="primary" class="numPadBtn" @click="weightAppend(7)">7</v-btn></v-flex>
                    <v-flex d-flex xs3 sm2><v-btn block color="primary" class="numPadBtn" @click="weightAppend(8)">8</v-btn></v-flex>
                    <v-flex d-flex xs3 sm2><v-btn block color="primary" class="numPadBtn" @click="weightAppend(9)">9</v-btn></v-flex>
                    <v-flex d-flex xs2 sm3><v-btn block color="warning" class="txtPadBtn" @click="weightRemove()"><v-icon class="d-md-none">backspace</v-icon><div class="d-none d-md-block">C</div></v-btn></v-flex>
                    <v-flex d-flex xs1 sm1></v-flex>
                  </v-layout>
                  <v-layout row wrap class="textsize-svs">
                    <v-flex d-flex class="ml-n5" xs1 sm1></v-flex>
                    <v-flex d-flex xs3 sm2><v-btn block color="primary" class="numPadBtn" @click="weightAppend(4)">4</v-btn></v-flex>
                    <v-flex d-flex xs3 sm2><v-btn block color="primary" class="numPadBtn" @click="weightAppend(5)">5</v-btn></v-flex>
                    <v-flex d-flex xs3 sm2><v-btn block color="primary" class="numPadBtn" @click="weightAppend(6)">6</v-btn></v-flex>
                    <v-flex d-flex xs2 sm3><v-btn block color="error" class="txtPadBtn" @click="preventLeave = false; changeSetWeightStatus(''); $router.push({ name: redirectTo })"><v-icon class="d-md-none">cancel</v-icon><div class="d-none d-md-block">{{$t("Cancel")}}</div></v-btn></v-flex>
                    <v-flex d-flex xs1 sm1></v-flex>
                  </v-layout>
                  <v-layout row wrap class="textsize-svs">
                    <v-flex d-flex class="ml-n5" xs1 sm1></v-flex>
                    <v-flex d-flex xs3 sm2><v-btn block color="primary" class="numPadBtn" @click="weightAppend(1)">1</v-btn></v-flex>
                    <v-flex d-flex xs3 sm2><v-btn block color="primary" class="numPadBtn" @click="weightAppend(2)">2</v-btn></v-flex>
                    <v-flex d-flex xs3 sm2><v-btn block color="primary" class="numPadBtn" @click="weightAppend(3)">3</v-btn></v-flex>
                    <!-- <v-flex d-flex xs2 sm3><v-btn block color="success" class="txtPadBtn" @click="submit()" :loading="submitting"><v-icon class="d-md-none">done</v-icon><div class="d-none d-md-block">{{$t("Ok")}} {{buttonAppend}}</div></v-btn></v-flex> -->
                    <v-flex d-flex xs1 sm1></v-flex>
                  </v-layout>
                  <v-layout row wrap class="textsize-svs">
                    <v-flex d-flex class="ml-n5" xs1 sm1></v-flex>
                    <v-flex d-flex xs3 sm4><v-btn block color="primary" class="numPadBtn" @click="weightAppend(0)">0</v-btn></v-flex>
                    <v-flex d-flex xs3 sm2></v-flex>
                    <!-- <v-flex d-flex xs3 sm2><v-btn block color="primary" class="numPadBtn" @click="weightAppend(decimalSeparator)">{{decimalSeparator}}</v-btn></v-flex> -->
                    <v-flex d-flex xs5 sm3><v-btn block color="success" class="txtPadBtn" @click="form.weightNetString - smReg.TareWeight <= 0 ? confirmZeroKgDialog=true : preFinish()" :loading="submitting">{{$t(textBtnText)}} {{buttonAppend}}</v-btn></v-flex>
                    <v-flex d-flex xs1 sm1></v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>
          </div>
        </v-flex>

        <!-- SELECT ACTIVE SCALE DIALOG -->
        <v-dialog v-model="ScanMobileIdDialog" max-width="380" persistent>
          <v-card >
            <v-card-title @click="simulateWeightFromScanMobile" class="headline">{{$t("Scale weight input")}}</v-card-title>
            <v-divider class="mb-0"></v-divider>
            <v-card-actions>
              <v-card-text>
              <v-select class="mt-n2 mb-6" hide-details="true" :clearable="true" :items="ScaleList" v-model="selectedScale" :label="$t('Select active scale')"></v-select>
              <v-btn class="ml-9" x-large color="success" @click="ScanMobileIdDialog = false; saveScale(selectedScale)">{{$t("Ok")}}</v-btn>
              <v-btn class="ml-4" x-large color="primary" @click="ScanMobileIdDialog = false">{{$t("Cancel")}}</v-btn>
            </v-card-text>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="confirmZeroKgDialog" max-width="350">
          <v-card>
            <v-card-title class="headline">{{$t("NoWeightAdded")}}</v-card-title>
            <v-card-text>{{$t("NoWeightDescription")}}</v-card-text>
            <v-card-text>{{$t("Tare")}} (kg): {{TareWeight}}</v-card-text>
            <v-card-text>{{$t("WeightNet")}}: {{form.weightNetString - smReg.TareWeight}}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="confirmZeroKgDialog = false">{{$t("Ok")}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="areYouSureFinishDialog" max-width="400" persistent>
        <v-card>
          <v-card-title class="headline">{{$t("Finish")}}?</v-card-title>
          <template>
            <v-card-text class="font-weight-bold">{{$t(textFinishText)}}</v-card-text>
          </template>
          <v-card-actions>
            <v-spacer></v-spacer>
              <template>
                <v-btn ref="yesButton" color="success" @click="areYouSureFinishDialog = false; finishRegistration()">{{$t("Yes")}}</v-btn>
                <v-btn ref="noButton" color="primary" @click="areYouSureFinishDialog = false" autofocus>{{$t("No")}}</v-btn>
              </template>
            </v-card-actions>
        </v-card>
    </v-dialog>

      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import { app } from '@/main'
import * as ScanMobile from '@/modules/scan-mobile/scan-mobile'
import ct from '@/core/mixins/common-translations'
import rules from '@/core/mixins/common-rules'
import preventLeave from '@/core/mixins/preventLeave'
import * as LocalStorage from '@/core/local-storage'
import * as Security from '@/core/security'
import * as DateUtil from '@/core/date'
import * as Log from '@/core/logger'
import SVGIcons from '@/assets/svg/SVGIcons'
import * as Archive from '@/core/archive'

export default {
  mixins: [ct, rules, preventLeave],
  data: () => ({
    dataType: 'scan-mobile-registration',
    loading: true,
    submitting: false,
    confirmZeroKgDialog: false,
    valid: true,
    redirectTo: 'scan-mobile-registrations',
    decimalSeparator: ',',
    maxDecimalCount: 2,
    TareWeight: 0,
    tempTareValue: 0,
    edit: false,
    WeightFirst: 0,
    OriginalWeight: 0,
    areYouSureFinishDialog: false,
    transferRegistration: null,
    showFinishDialog: false,
    userName: Security.user.name.split('.')[1], // set username ex. SVS.Ole => Ole
    textBtnText: '2. Registration',
    textFinishText: 'Do you want to finish 2. Registration.',
    form: {
      weightNet: 0,
      weightNetString: '',
      currentWeightString: ''
    },
    smReg: {
      id: '00000000-0000-0000-0000-000000000000',
      registrationId: '00000000-0000-0000-0000-000000000000',
      facilityNo: null,
      finishedDate: null,
      finishedBy: null,
      comment: null,
      reg: null,
      TareWeight: 0,
      Registration: { WeightFirst: 0, WeightSecond: 0 }
    },
    ScanMobileIcon: SVGIcons.ScanMobileScaleIcon,
    enableScaleWeightIntegration: false,
    isAlive: true,
    // ScaleIpPort: '0.0.0.0:1234',
    checkIsAliveTimer: null,
    checkkingIsAlive: false,
    activeScale: null,
    selectedScale: null,
    displayWeight: '',
    ScanMobileIdDialog: false,
    ScaleList: [],
    // allowSimulation: false, // if ScaleList from server is empty allow simulation weight for 'Scale #1' and 'Scale #2' by left click on the weight
    simulationWeight: 0,
    firstErrorStatus: '',
    firstReg: false,
    tareVehicle: false,

    errorTexts: [
      { text: 'S', value: 'The scale is stable, with a valid weight.' },
      { text: 'U', value: 'The scale is in an unstable condition. Please wait and try again.' },
      { text: 'Timeout', value: 'Timeout. Weight data too old (>10 secs). Please wait and try again.' },
      // TODO: Perhaps delete the rest of these error texts
      { text: 'Z', value: 'The scale must be set to zero.' },
      { text: 'WU', value: 'Warm-up strokes must be performed.' },
      { text: 'W', value: 'Weighing allowed.' },
      { text: 'WB', value: 'As for Weighing allowed, but with re-weighing active.' },
      { text: 'F', value: 'The contents of the bucket have been weighed and added. The loading bucket must be emptied.' },
      { text: 'ENA', value: 'Error: top of zero range exceeded.' },
      { text: 'ENI', value: 'Error: bottom of zero range exceeded.' },
      { text: 'ES', value: 'Error: unstable weighing process.' },
      { text: 'EWA', value: 'Error: maximum load exceeded.' },
      { text: 'EWI', value: 'Error: minimum load required.' },
      { text: 'ET', value: 'Error: vehicle is tilted.' },
      { text: 'ELSF', value: 'Error: Alibi memory is full.' },
      { text: 'ZERO', value: 'The scale cannot be set to zero. Check Scale is ON. If ON, press "Stand-By" and touch screen, to turn ON again.' },
      { text: 'NoWeight', value: 'No Weight data ready. Please wait. Check Scale is ON. If ON, press "Stand-By" and touch screen, to turn ON again.' },
      { text: 'ResetWeight', value: 'The scale must be reset to zero. Please wait and try again.' }
    ],
    hiddenFields: []

  }),
  computed: {},
  methods: {
    getWeightStr (smReg) {
      // Weighing is via ScanMobile
      return (smReg.Registration.WeightFirst - this.smReg.TareWeight) + ' kg'
    },
    async finishRegistration () {
      // Grab an update of the reg to get ScanXRegNo etc.
      const res2 = await ScanMobile.loadRegistration(this.smReg.id)
      if (!res2.failed) {
        if (res2.data != null) {
          const comment = this.smReg.Registration.Comment1
          // this.smReg.Registration = res2.data.Registration
          this.smReg.Registration.ScanXRegNo = res2.data.Registration.ScanXRegNo
          this.smReg.Registration.Comment1 = comment
        }
      }

      var date = new Date()
      // Tare calulation for ScanMobile ONLY on Finish reg (Also im FinishRegistration.vue)
      this.smReg.Registration.DateFirst = new Date()
      if (!this.firstReg || this.TareWeight > 0 || this.tareVehicle) {
        if (this.TareWeight > 0 || this.tareVehicle) {
          this.smReg.Registration.WeightSecond = this.smReg.TareWeight
          this.smReg.Registration.WeightFirst = this.form.weightNetString
        } else if (this.tempTareValue > 0) {
          this.smReg.Registration.WeightSecond = this.tempTareValue
          this.smReg.Registration.WeightFirst = this.form.weightNetString
        } else {
          this.smReg.Registration.WeightFirst = this.OriginalWeight
          this.smReg.Registration.WeightSecond = this.form.weightNetString
        }
        this.smReg.Registration.DateSecond = new Date()
        this.smReg.Registration.WeightNet = this.smReg.Registration.WeightFirst - this.smReg.Registration.WeightSecond
      } else if (this.tempTareValue === 0) {
        date = null
        this.smReg.finishedBy = null
      }

      var convertedValue = this.checkWeightInput()
      if (convertedValue == null) return
      this.updateWeight(convertedValue)
      this.submitting = true
      this.confirmDialog = false
      this.preventLeave = false
      const res = await ScanMobile.saveRegistration({
        Id: this.smReg.id,
        RegistrationId: this.smReg.registrationId,
        Facility: this.smReg.facilityNo,
        FinishedDate: date,
        FinishedBy: this.smReg.finishedBy,
        Comment: this.smReg.comment,
        Registration: this.smReg.Registration,
        TransferRegistration: this.transferRegistration,
        Storage1: this.smReg.Storage1,
        Storage2: this.smReg.Storage2,
        StorageT1: this.smReg.StorageT1,
        StorageT2: this.smReg.StorageT2
      })
      this.submitting = false
      if (!res.failed) {
        this.preventLeave = false
        this.$root.$message.showSuccess(this.$t('Registration finished'))
        this.$router.push({ name: this.redirectTo })
      }
    },
    // Append the char to the weight
    weightAppend (char) {
      // Start checking the rules.
      if (this.form.weightNetString === '0') {
        if (char >= 1 && char <= 9) {
          // If already entered 0, and entering a value between 1 and 9, then remove the 0.
          this.form.weightNetString = ''
        } else if (char === 0) {
          // If already entered 0, and entering 0 again, then ignore it.
          return
        }
      } else if (this.form.weightNetString === '') {
        if (char === this.form.decimalSeparator) {
          // If the string is empty, and entering comma, then add a 0 first.
          this.form.weightNetString = '0'
        }
      } else if (this.form.weightNetString.indexOf(this.form.decimalSeparator) > -1) {
        if (char === this.form.decimalSeparator) {
          // If the string already contains a comma, and entering comma again, then ignore it.
          return
        }

        // Count the number of decimals already entered.
        var decimalCount = this.form.weightNetString.split(this.form.decimalSeparator)[1].length || 0
        if (decimalCount >= this.form.maxDecimalCount) {
          // If more decimals than allowed are already entered, then ignore them.
          // But let's tell the user
          this.$root.$message.showInfo(this.$t('No more decimals are allowed.'))
          return
        }
      }

      // Now append the new char
      this.form.weightNetString += ('' + char)
      if (this.firstReg && this.TareWeight === 0) {
        this.smReg.Registration.WeightFirst = this.form.weightNetString
      } else {
        this.smReg.Registration.WeightSecond = this.form.weightNetString
      }
    },
    saveVT25 () {
      this.activeVT25 = this.selectedVT25
      LocalStorage.save('activeScanMobileIndicator', this.activeVT25)
    },
    preFinish () {
      if (this.showFinishDialog) {
        this.areYouSureFinishDialog = true
      } else {
        this.finishRegistration()
      }
    },
    weightRemove () {
      this.form.weightNetString = this.form.weightNetString.substr(0, this.form.weightNetString.length - 1)
      if (this.firstReg) {
        this.smReg.Registration.WeightFirst = this.form.weightNetString
      } else {
        this.smReg.Registration.WeightSecond = this.form.weightNetString
      }
    },
    checkWeightInput () {
      // Convert the weightNetString to weightNet
      var convertedValue = parseFloat(this.form.weightNetString)
      if (convertedValue === undefined || convertedValue === null || isNaN(convertedValue)) {
        this.$root.$message.showError(this.$t('Invalid format of entered weight'))
        return null
      }

      // The type of WeightNet in the database is a Decimal(18,6)
      // The maximum number of a Decimal(18,6) is (18-6)=12x '9' before the separator and 6x '9' after the separator. So 999999999999,999999
      // Let's just check for 6x '9' without the decimals.
      if (convertedValue > 99999999) {
        this.$root.$message.showError(this.$t('WeightWayTooBig'))
        return null
      }
      return convertedValue
    },
    updateWeight (weight) {
      this.form.weightNet = weight
      this.smReg.Registration.DateFirst = new Date()
      this.smReg.Registration.WeightFirst = this.form.weightNet
      if (this.tempTareValue > 0 || this.TareWeight > 0 || this.tareVehicle) {
        this.smReg.Registration.WeightFirst = this.tempTareValue
        this.smReg.Registration.WeightSecond = this.form.weightNet
        if (this.TareWeight > 0 || this.tareVehicle) {
          this.smReg.Registration.WeightFirst = this.TareWeight
        }
        this.smReg.Registration.WeightNet = this.smReg.Registration.WeightFirst - this.smReg.Registration.WeightSecond
      } else if (!this.firstReg) {
        this.smReg.Registration.WeightFirst = this.OriginalWeight
        this.smReg.Registration.WeightNet = this.smReg.Registration.WeightFirst - this.smReg.Registration.WeightSecond
      } else {
        this.smReg.Registration.WeightNet = this.smReg.Registration.WeightFirst - this.smReg.TareWeight
      }
    },
    async get_Scan_Mobile_Weight () {
      // First time Select active Scale
      if (!this.activeScale) {
        this.ScanMobileIdDialog = true
        return
      }
      this.isAlive = false // disable ScanMobile button

      // Get Scale sum weight
      const res = await ScanMobile.getWeight({ ScaleId: this.activeScale, ResetWeight: 'False' })
      if (!res.failed) {
        if (res.data.Status === 'S') {
          if (res.data.TotalWeight > 0) {
            this.form.weightNetString = res.data.TotalWeight.toString()
            this.updateWeight(res.data.TotalWeight)
            this.$root.$message.showInfo(this.$t('Weight') + ' ' + this.form.weightNetString + ' kg ' + this.$t('transferred'))
            this.firstErrorStatus = ''
          } else {
            this.$root.$message.showError(this.$t('NoWeightAdded') + ' (0 kg)')
          }
        } else {
          if (res.data.Status === 'U') {
            this.form.weightNetString = res.data.TotalWeight.toString()
            const error = this.errorTexts.find(e => e.text === res.data.Status).value
            this.$root.$message.showError(error)
          } else {
            if (!this.firstErrorStatus) this.firstErrorStatus = res.data.Status
            const errorTxt = this.errorTexts.find(e => e.text === this.firstErrorStatus).value
            const error = this.$t('Weight communication problem. Check Scale is Ready.') + ' [Code: ' + this.firstErrorStatus + '] ' + errorTxt
            this.$root.$message.showError(error)
            Log.log('Error in get_Scan_Mobile_Weight:', error, res.data)
          }
        }
        this.isAlive = true // enable ScanMobile button
        this.displayWeight = ''
      }
    },
    ScanMobileIdHandler (event) {
      this.selectedScale = this.activeScale
      this.ScanMobileIdDialog = !this.ScanMobileIdDialog
      event.preventDefault()
    },
    saveScale () {
      if (this.selectedScale) {
        this.activeScale = this.selectedScale
        LocalStorage.save('activeScale', this.activeScale)
      } else {
        LocalStorage.remove('activeScale')
        this.ScaleList = []
      }
    },
    async simulateWeightFromScanMobile () {
      if (!this.activeScale) {
        console.log('>> ScaleList = "Scale #1"')
        // Simulation Scale ids, if none found in service (no Scale is sending Weight results yet)
        // simulateWeightFromScanMobile: click on headline "Scan Mobile weight input" in
        // Select active Scan Mobile via Scan Mobile button long press (contextmenu)
        this.ScaleList = ['Scale #1']
        this.activeScale = 'Scale #1'
        this.selectedScale = 'Scale #1'
      } else {
        const res = await ScanMobile.uploadWeight({
          ScaleId: this.activeScale,
          ScaleWeightData: {
            AddedDate: DateUtil.getRealDate(Date.now()),
            NumberOfWeighings: 1,
            Status: (this.simulationWeight / 100) % 3 === 0 ? 'U' : 'S',
            TotalWeight: this.simulationWeight,
            Unit: 'kg',
            VoucherNumber: 1
          }
        })
        this.simulationWeight += 100
        if (res.failed) { console.log('>> simulate uploadWeight() error') }
      }
    },

    async submit () {
      // Grab an update of the reg to get ScanXRegNo etc.
      const res2 = await ScanMobile.loadRegistration(this.smReg.id)
      if (!res2.failed) {
        const comment = this.smReg.Registration.Comment1
        this.smReg.Registration.ScanXRegNo = res2.data.Registration.ScanXRegNo
        this.smReg.Registration.Comment1 = comment
      }

      var convertedValue = this.checkWeightInput()
      if (convertedValue == null) return
      this.updateWeight(convertedValue)
      this.submitting = true
      const res = await ScanMobile.saveRegistration({
        Id: this.smReg.id,
        RegistrationId: this.smReg.registrationId,
        Facility: this.smReg.facilityNo,
        FinishedDate: this.smReg.finishedDate,
        FinishedBy: this.smReg.finishedBy,
        Comment: '', // clear InUseBy
        Registration: this.smReg.Registration,
        TransferRegistration: this.transferRegistration
      })
      this.submitting = false
      if (!res.failed) {
        this.preventLeave = false
        this.$root.$message.showSuccess(this.form.weightNet + ' kg ' + this.$t('Saved').toLowerCase())
        this.$router.push({ name: this.redirectTo })
      }
    },
    async handleSingleTare (id) {
      if (id === undefined) {
        return
      }
      const data = await ScanMobile.getTempTare(id)
      if (data.data != null) {
        this.tempTareValue = data.data.Value
      }
      if (this.TareWeight > 0 || this.tempTareValue > 0) {
        this.form.weightNetString = this.smReg.Registration.WeightSecond.toString()
      } else {
        if (this.firstReg) {
          this.form.weightNetString = this.smReg.Registration.WeightFirst.toString()
        } else {
          this.form.weightNetString = this.smReg.Registration.WeightSecond.toString()
        }
      }
      this.form.weightNetString = '0'
    },
    async changeSetWeightStatus (val) {
    },
    isHide (fieldName) {
      return this.hiddenFields.some(h => h === fieldName)
    }
  },
  beforeDestroy () {
    // Stop live poll Scale getWeight
    if (this.getLiveWeightTimer) {
      this.checkkingIsAlive = false
      clearInterval(this.getLiveWeightTimer)
    }
    if (this.getRegTimer) clearInterval(this.getRegTimer)
  },
  async mounted () {
    // We use next tick to ensure that app is initialized
    this.$nextTick(() => {
      app.$on('force-update', () => {
        // We need this to ensure that autoLogin re-renders component
        this.$forceUpdate()
      })
    })
    const res = await ScanMobile.getCurrentWeightIds()
    if (!res.failed && res.data.length) {
      this.ScaleList = res.data
    }
    // Use Settings from cached user's corporatationDetails
    if (Security.user.corporationDetails) {
      this.enableScaleWeightIntegration = true // TODO: (Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_Enable_Scale_Weight_Integration')?.Data1 === 'true')
      const defaultHidden = 'RequisitionNo2,Carrier,Comment' // New fields default hidden LSV/MITH. Remember to also add new defaults in Settings.vue and Registration.vue
      this.hiddenFields = (Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_Fields_Hidden')?.Data1 ?? defaultHidden).split(',')
      var noValue = Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_Show_Finish_Dialog')?.Data1 === undefined ?? false
      if (noValue) {
        this.showFinishDialog = true
      } else {
        this.showFinishDialog = Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_Show_Finish_Dialog')?.Data1 === 'true' ?? false
      }
    }
    if (this.$route.params.id) {
      this.smReg.id = this.$route.params.id
      this.edit = this.$route.params.edit
      const res = await ScanMobile.loadRegistration(this.smReg.id)
      if (!res.failed) {
        if (res.data === null) {
          res.data = this.$route.params.reg
        }
        if (res.data.Registration.WeightFirst > 0) {
          const Sreg = res.data.Registration.ScanXRegNo
          if (this.$route.params.reg !== undefined) {
            res.data = this.$route.params.reg
          }
          if (Sreg !== '') {
            res.data.Registration.ScanXRegNo = Sreg
          }
        }

        this.smReg.registrationId = res.data.RegistrationId
        this.smReg.facilityNo = res.data.facilityNo
        this.smReg.finishedDate = res.data.FinishedDate
        this.smReg.finishedBy = res.data.FinishedBy
        this.smReg.CreatedBy = res.data.CreatedBy
        this.smReg.comment = res.data.Comment
        this.smReg.Registration = res.data.Registration
        this.smReg.Storage1 = this.$route.params.s1
        this.smReg.Storage2 = this.$route.params.s2
        this.smReg.StorageT1 = this.$route.params.st1
        this.smReg.StorageT2 = this.$route.params.st2
        if (this.smReg.facilityNo === undefined) {
          this.smReg.facilityNo = res.data.Facility
        }
        if (!this.firstReg) {
          this.OriginalWeight = res.data.Registration.WeightFirst
        }
        var res2 = await Archive.loadVehicle({ facilityNo: this.smReg.facilityNo, vehicleNo: this.smReg.Registration.VehicleNo })
        if (!res2.failed) {
          this.smReg.TareWeight = Math.round(res2.data.Details.find(o => o.Name === 'TareWeight')?.Value ?? 0)
          this.tareVehicle = Math.round(res2.data.Details.find(o => o.Name === 'RegistrationMethod')?.Value ?? 0)
          this.TareWeight = this.smReg.TareWeight
          if (this.smReg.id === '00000000-0000-0000-0000-000000000000') {
            if (!this.tareVehicle) {
              this.firstReg = true
            }
          }
          await this.handleSingleTare(res2.data.Id)
          if (!this.tareVehicle) {
            if ((!res.data.Id && this.tempTareValue < 1 && this.TareWeight < 1) || this.smReg.id === '00000000-0000-0000-0000-000000000000' || this.edit) {
              if (this.tempTareValue < 1 && this.TareWeight < 1) {
                this.textBtnText = '1. Registration'
                this.textFinishText = 'Do you want to finish 1. Registration.'
              }
              this.firstReg = true
            }
          }
        }

        if (this.$route.params.transferRegistration !== undefined) {
          this.transferRegistration = this.$route.params.transferRegistration
        }
      }
    } else {
      // ERROR
      // Calling this view incorrectly.
      this.$root.$message.showError(this.$t('Invalid registration id'))
    }

    this.$nextTick(() => {
      this.loading = false
    })

    this.changeSetWeightStatus(this.userName) // Set Weight Status to 'Set weight (userName)' // InUseBy
  }
}
</script>
